import { Link } from "@react-pdf/renderer";
import classNames from "classnames";
import * as React from "react";

type Props = {
  url: string;
  pdf?: boolean;
  className?: string;
};

const ExternalLink: React.FC<Props> = props => {
  if (props.pdf) {
    return <Link src={props.url} style={{ color: '#0056b3' }}>{props.children}</Link>;
  }

  return (
    <a
      className={classNames('link', props.className)}
      href={props.url}
      target="blank"
    >
      {props.children}
    </a>
  );
};

export default ExternalLink;

type EmailProps = {
  email: string;
  className?: string;
};

export const MailLink: React.FC<EmailProps> = props => {
  const url = `mailto:${props.email}`;

  return (
    <ExternalLink url={url} className={props.className}>{props.email}</ExternalLink>
  );
};
